<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  show: { type: Boolean, default: false },
});

const emit = defineEmits(['close']);
const { t } = useI18n();
</script>

<template>
  <Teleport to="body">
    <section
      v-if="show"
      data-testid="nucleo-work-order-completion-feedback"
      role="status"
      aria-live="polite"
      class="fixed inset-x-4 bottom-10 z-[1000] rounded-[10px] border border-lais-border bg-white p-6 shadow-[0_2px_4px_rgba(0,0,0,0.08),0_0_6px_rgba(0,0,0,0.02)] sm:left-auto sm:w-[560px] sm:max-w-[calc(100vw-2rem)] sm:p-8"
    >
      <header class="flex justify-end">
        <button
          type="button"
          class="grid size-8 place-items-center rounded-full text-lais-text-muted hover:bg-lais-bg-soft focus-visible:outline-none focus-visible:shadow-lais-focus"
          :aria-label="t('NUCLEO_WORK_ORDERS.COMPLETION_FEEDBACK.CLOSE')"
          @click="emit('close')"
        >
          <span class="i-lucide-x size-4" aria-hidden="true" />
        </button>
      </header>
      <h2
        class="mt-2 font-redHatDisplay text-lg font-semibold leading-7 text-lais-text sm:text-xl"
      >
        {{ t('NUCLEO_WORK_ORDERS.COMPLETION_FEEDBACK.TITLE') }}
      </h2>
      <p class="mt-2 max-w-[445px] text-sm leading-6 text-lais-text-body">
        {{ t('NUCLEO_WORK_ORDERS.COMPLETION_FEEDBACK.DESCRIPTION') }}
      </p>
    </section>
  </Teleport>
</template>
